// extracted by mini-css-extract-plugin
module.exports = {"mobileMenu":"index_mobileMenu_3DQNN","main-layout-content":"index_main-layout-content_2nRct","handler":"index_handler_3d1jz","handlerIcon":"index_handlerIcon_eT4k6"};